"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var types_1 = require("./types");
var compiler_1 = require("./utils/compiler");
var dependencies_1 = require("./utils/dependencies");
var reduce_1 = require("./utils/reduce");
var sort_1 = require("./utils/sort");
var transform_1 = require("./utils/transform");
__export(require("./types"));
__export(require("./features/expression/expression"));
var DEFAULT_LOAD_FN = function () { return ({}); };
var DEFAULT_OPTIONS = {
    errorOnCircularDep: types_1.ErrorLevel.WARN,
    errorOnUnknownDep: types_1.ErrorLevel.WARN,
    errorOnEval: types_1.ErrorLevel.WARN,
    visitor: undefined,
    loadExpressions: DEFAULT_LOAD_FN,
};
var createSelector = reselect_1.createSelectorCreator(reselect_1.defaultMemoize, function (a, b) { return JSON.stringify(a) === JSON.stringify(b); });
exports.expressionEnhancer = function (options) { return function (createStore) { return function (reducer, preloadedState) {
    var config = __assign({}, DEFAULT_OPTIONS, options);
    var store = createStore(reducer, preloadedState);
    var compiler = compiler_1.createExpressionCompiler(config);
    var dependenciesBuilder = dependencies_1.createDependenciesBuilder(config);
    var sorter = sort_1.createExpressionSorter(config);
    var transformer = transform_1.createExpressionTransformer(config);
    var evaluator = reduce_1.createExpressionReducer(config);
    var getMemoizeState = createSelector(function (state) { return state; }, function (state) {
        var expressionByPath = options.loadExpressions(state);
        if (expressionByPath === undefined || expressionByPath === null) {
            return state;
        }
        var nodeByPath = compiler(expressionByPath);
        var transformedNodesByPath = transformer(nodeByPath);
        var dependenciesByPath = dependenciesBuilder(transformedNodesByPath);
        var sortedPaths = sorter(dependenciesByPath);
        return sortedPaths.reduce(evaluator(transformedNodesByPath), state);
    });
    var getState = function () { return getMemoizeState(store.getState()); };
    var getOriginalState = function () { return store.getState(); };
    return __assign({}, store, { getState: getState, getOriginalState: getOriginalState });
}; }; };
//# sourceMappingURL=index.js.map